import { ResponsiveScreenSizesInt } from "app/utils/const";
import { useEffect, useState } from "react";

interface ImageVariant {
  url: string;
  alt: string;
}

interface LandingPageImageProps {
  desktopImage: ImageVariant;
  mobileImage: ImageVariant;
  className?: string;
}

const LandingPageImage = ({
  desktopImage,
  mobileImage,
  className = "",
}: LandingPageImageProps) => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ResponsiveScreenSizesInt.mobile
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ResponsiveScreenSizesInt.mobile);
    };

    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const selectedImage = isMobile ? mobileImage : desktopImage;

  return (
    <img
      src={selectedImage.url}
      alt={selectedImage.alt}
      className={className}
    />
  );
};

export default LandingPageImage;
